// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type CaretLeftIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from caret-left.svg
 */
export default function CaretLeftIcon(props: CaretLeftIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="CaretLeftIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M9.293 3.293a1 1 0 0 1 1.497 1.32l-.083.094L7.415 8l3.292 3.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083-4-4a1 1 0 0 1-.083-1.32l.083-.094z"
        />
      </g>
    </svg>
  );
}
